<template>
  <section class="callback">
    <div class="callback-loader">
      <div class="callback-loader__icon">Loading...</div>
      <div class="callback-loader__bars">
        <div class="callback-loader__bar"></div>
        <div class="callback-loader__bar"></div>
        <div class="callback-loader__bar"></div>
      </div>
    </div>
  </section>
</template>

<script>
  import { getShopDomain, setIdToken, setAccessToken, setShopDomain, setCallbackShopDomain } from '@/utils/auth.js'

  import axios from 'axios'

  export default {
    name: 'callback',
    data () {
      return {
        user: null
      }
    },
    methods: {
      createCharge () {
        return axios({
          url: `platforms/shopify/charge/${this.$domain}`
        })
        .then((response) => {
          return response.data.confirmation_url
        })
        .catch((error) => {
          console.log(error)
          return false
        })
      }
    },
    mounted () {
      setAccessToken()
      setIdToken()
      setCallbackShopDomain()

      this.loadUser().then(() => {
        let domain = getShopDomain()
        this.$domain = domain

        if (!domain && this.user.domains && this.user.domains.length > 0) {
          // If no domain set default to the user's first domain
          domain = this.user.domains[0]
          setShopDomain(domain)
          this.$domain = domain
          window.location.href = '/'
        } else if (!this.user.domains || !this.user.domains.includes(domain)) {
          // Otherwise check for access to domain and send the user
          // to authorize access
          this.loadAuthUrl().then((url) => {
            if (url) {
              window.location.href = url
            } else {
              window.location.href = '/'
            }
          })
        } else if (this.$shop && !this.$shop.active) {
          // If shop is not active, setup their charge
          this.createCharge().then((url) => {
            if (url) {
              window.top.location.href = url
            } else {
              window.location.href = '/welcome'
            }
          })
        } else if (this.$shop && !this.$shop.initial_import) {
          // Import is not complete, send them to welcome
          window.location.href = '/welcome'
        } else {
          // Authorized, send them home
          window.location.href = '/'
        }
      })
    }
  }
</script>

<style module>
  body {
    background: #fff;
  }
</style>


// WEBPACK FOOTER //
// src/js/pages/Callback.vue